import { createApi } from '@reduxjs/toolkit/query/react';
import { BaseQueryWithReAuth } from '../utils';
import { dcuFirmwareUpgradeEndpoints } from './endpoints/dcuFirmwareUpgrade';

export const dcuUpgradeBaseQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_LEGACY_DCU_FW_UPGRADE_BASE_URL}/`,
  credentials: 'same-origin',
  setHeaders(headers) {
    headers.append('Authorization', localStorage.getItem('hes_token') || '');
    return headers;
  }
});

const dcuFWApi = createApi({
  reducerPath: 'dcuFWApi',
  baseQuery: dcuUpgradeBaseQuery,
  endpoints: (builder) => ({
    ...dcuFirmwareUpgradeEndpoints(builder)
  })
});

export const {
  useGetDCUBatchListQuery,
  useFetchDCUBatchDetailsQuery,
  useExecuteDCUFWUpgradeCommandMutation,
  useUploadFirmwareFileMutation,
  usePrefetch
} = dcuFWApi;

export default dcuFWApi;
